import PatientIcon from "../../assets/icon/PatientIcon";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
}

export const SearchInput = ({ value, onChange }: SearchInputProps) => {
  return (
    <div className="search-wrapper">
      <PatientIcon className="search-icon" />
      <input
        type="text"
        className="search-input"
        placeholder="Search patient.."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};
